<div class="duration-info">
    <p class="name">{{ task.operationTask.name }}</p>
    <i class="fa fa-clock-o"></i>
    <p class="duration">
        {{ task.operationTask.duration * toolCount }} {{ task.operationTask.unit }}
        <span>({{ (toolCount === 1
            ? 'service.tickets.details.activityDetails.singleToolCount'
            : 'service.tickets.details.activityDetails.multipleToolCount') | translate : {count: toolCount} }})</span>
    </p>
</div>
<div class="info-message row" *ngIf="infoMessage"><i class="material-icons">info</i> {{ infoMessage }}</div>
<div class="required-info row">
    <app-input-switch
        onLabel="{{'service.tickets.details.activityDetails.requiresObservation' | translate}}"
        [disabled]="isRequiresObservationDisabled(task)"
        [(ngModel)]="task.requiresObservation"
        (inputChange)="updateTicketTask()">
    </app-input-switch>
    <app-input-switch *ngIf="task.operationTask?.hasSpare"
                      onLabel="{{'service.tickets.details.activityDetails.requiresSpare' | translate}}"
                      [disabled]="isRequiresSpareDisabled(task)"
                      [(ngModel)]="task.requiresSpare"
                      (inputChange)="updateTicketTask()">
    </app-input-switch>
</div>
<div class="recurrences">
    <span style="font-weight: bold">{{ 'service.tickets.details.activityDetails.recurrences' | translate }}:</span>
    <span>{{ computeRecurrences(task) }}</span>
</div>
<div class="description">
    <span style="font-weight: bold">{{ 'service.tickets.details.activityDetails.instructions' | translate }}: </span>
    <span [innerHTML]="formatDescription(task.operationTask.description)"></span>
</div>
<div class="description" *ngIf="task.status !== 0"
     [class.done]="task.status===1"
     [class.not-done]="task.status===2">
    <span style="font-weight: bold">{{'service.tickets.details.activityDetails.status' | translate }}: </span>
    <span>{{
            'service.tickets.details.activityDetails.completedBy'
                | translate: {
                name: task.completedByName,
                date: task.endDate ? (task.endDate | date: 'dd-MM-yyyy HH:mm') : 'N/A'
            }
        }}</span>
    <p *ngIf="task.status===2">
        <span style="font-weight: bold">{{ 'service.tickets.details.activityDetails.notDoneReason'| translate }}
            : </span> {{ task.notDoneReason }}</p>
    <p *ngIf="task.status===1 && task.comment">
        <span style="font-weight: bold"> {{ 'service.tickets.details.activityDetails.observations' | translate }}
            :</span> {{ task.comment }}</p>
    <p *ngIf="task.status===1 && task.operationTask.hasSpare">
        <span style="font-weight: bold">{{ 'service.tickets.details.activityDetails.sparesUsed'| translate }}
            : </span>{{ task.spareQuantity }}
    </p>
</div>
<div class="spare" *ngIf="task.operationTask.hasSpare">
    <div class="info row">
        <p class="header">{{ 'service.tickets.details.activityDetails.involvesSpare' | translate }}</p>
        <p class="spare-details">{{
                'service.tickets.details.activityDetails.spareDetails'
                    | translate: {code: task.operationTask.spareCode, quantity: task.operationTask.spareQuantity}
            }}</p>
    </div>
    <div class="row documents">
        <div class="row action">
            <div class="spare-files row action" (click)="onDownloadDocuments($event, true)"
                 *ngIf="hasInstructionDocument(task, true)">
                <i class="fa fa-file-text"></i>
                <p class="spare-document">{{ 'service.tickets.details.activityDetails.downloadSpareDocument' | translate }}</p>
            </div>
        </div>
        <div class="row action">
            <div class="spare-files row action" (click)="onPreviewDocuments($event, true)"
                 *ngIf="hasInstructionDocument(task, true)">
                <i class="fa fa-search-plus"></i>
                <p class="spare-document">{{ 'service.tickets.details.activityDetails.seeSpareDocument' | translate }}</p>
            </div>
        </div>
    </div>
</div>
<div class="row documents">
    <div class="action" (click)="onDownloadDocuments($event)"
         [class.disabled]="!hasInstructionDocument(task, false)">
        <i class="fa fa-file-text-o"></i>
        <p>{{ 'service.tickets.details.activityDetails.downloadWorkInstructions' | translate }}</p>
    </div>
    <div class="action" (click)="onPreviewDocuments($event)"
         [class.disabled]="!hasInstructionDocument(task, false)">
        <i class="fa fa-search-plus"></i>
        <p>{{ 'service.tickets.details.activityDetails.seeWorkInstructions' | translate }}</p>
    </div>
</div>
<div class="row documents">
    <div *ngIf="photos.length > 0" class="row photos action" (click)="toggleCarouselVisible($event)">
        <i class="fa fa-picture-o"></i>
        <p>{{
                (carouselVisible
                    ? 'service.tickets.details.activityDetails.hidePhotos'
                    : 'service.tickets.details.activityDetails.seePhotos')
                    | translate
            }}
        </p>
    </div>
</div>

<app-photo-carousel *ngIf="carouselVisible && photos && photos.length > 0"
                    [photos]="photos"
                    [numVisibleItems]="1"
                    [canDelete]="false">
</app-photo-carousel>
